var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.797,
    height: 12.34,
    viewBox: "0 0 10.797 12.34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4508",
    "data-name": "Path 4508",
    d: "M0,308.438A4.368,4.368,0,0,1,4.3,304H6.5a4.368,4.368,0,0,1,4.3,4.438.728.728,0,0,1-.716.739H.716A.728.728,0,0,1,0,308.438Z",
    transform: "translate(0 -296.837)",
    fill: "#0d47a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M96,3.186a3.014,3.014,0,1,1,6.018,0,3.014,3.014,0,1,1-6.018,0Z",
    transform: "translate(-93.611 0)",
    fill: "#888",
    opacity: 0.801
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-4.06b20d36eecfbdc08a0b35d106754de0.svg";